var map = {
	"./About.vue": [
		"f820",
		"layout-views-About-vue"
	],
	"./Contacts.vue": [
		"c93c",
		"layout-views-Contacts-vue"
	],
	"./Doctors.vue": [
		"d03d",
		"layout-views-Doctors-vue"
	],
	"./Home.vue": [
		"bb51"
	],
	"./Info.vue": [
		"2469",
		"layout-views-Info-vue"
	],
	"./Police.vue": [
		"ea53",
		"layout-views-Police-vue"
	],
	"./Price.vue": [
		"d3be",
		"layout-views-Price-vue"
	],
	"./news/News.vue": [
		"5884",
		"layout-views-news-News-vue"
	],
	"./news/NewsPost.vue": [
		"06fb",
		"layout-views-news-NewsPost-vue"
	],
	"./service/Service.vue": [
		"9824",
		"layout-components-service-Card-vue",
		"layout-views-service-Service-vue"
	],
	"./service/ServicePost.vue": [
		"dbfd",
		"layout-views-service-ServicePost-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;